import { createSlice, createAsyncThunk, nanoid } from "@reduxjs/toolkit";
import axios from "axios";

export const registerContractor = createAsyncThunk(
  "contractor/register",
  async (formData) => {
    const config = {
      header: {
        "Content-type": "application/json",
      },
    };
    console.log("AT thunk:", formData);
    try {
      console.log("Userslice:", formData);
      const request = await axios.post(
        "/api/contractor/addContractor",
        formData,
        config
      );
      const response = await request.data;
      console.log("AT thunk:", response);
      localStorage.setItem("user", JSON.stringify(response));
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        console.error("Error response from server:", error.response.data);
        console.error("Status code:", error.response.status);
        console.error("Headers:", error.response.headers);
        // Show appropriate error message to the user
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        // Show appropriate error message to the user
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Error setting up the request:", error.message);
        // Show appropriate error message to the user
      }
      // Handle error scenario (e.g., show error modal)
    }
  }
);

export const getAllContractors = createAsyncThunk(
  "contractor/manage",
  async () => {
    const config = {
      header: {
        "Content-type": "application/json",
      },
    };
    try {
      const request = await axios.get(
        "/api/contractor/getAllContractors",
        config
      );
      const response = await request.data;
      console.log("AT thunk:", response);
      localStorage.setItem("user", JSON.stringify(response));
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        console.error("Error response from server:", error.response.data);
        console.error("Status code:", error.response.status);
        console.error("Headers:", error.response.headers);
        // Show appropriate error message to the user
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        // Show appropriate error message to the user
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Error setting up the request:", error.message);
        // Show appropriate error message to the user
      }
      // Handle error scenario (e.g., show error modal)
    }
  }
);

export const registerEmployee = createAsyncThunk(
  "employee/register",
  async (formData) => {
    const config = {
      header: {
        "Content-type": "application/json",
      },
    };
    console.log("AT thunk:", formData);
    try {
      console.log("Userslice:", formData);
      const request = await axios.post(
        "/api/employee/addEmployee",
        formData,
        config
      );
      const response = await request.data;
      console.log("AT thunk:", response);
      localStorage.setItem("user", JSON.stringify(response));
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        console.error("Error response from server:", error.response.data);
        console.error("Status code:", error.response.status);
        console.error("Headers:", error.response.headers);
        // Show appropriate error message to the user
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
        // Show appropriate error message to the user
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Error setting up the request:", error.message);
        // Show appropriate error message to the user
      }
      // Handle error scenario (e.g., show error modal)
    }
  }
);

export const registerUser = createAsyncThunk(
  "user/registerUser",
  async (userCredentials) => {
    const config = {
      header: {
        "Content-type": "application/json",
      },
    };
    console.log("AT thunk:", response);
    const request = await axios.post(
      "/api/users/register",
      userCredentials,
      config
    );
    const response = await request.data;
    console.log("AT thunk:", response);
    localStorage.setItem("user", JSON.stringify(response));
    return response;
  }
);

export const loginUser = createAsyncThunk(
  "user/loginUser",
  async (userCredentials) => {
    const config = {
      header: {
        "Content-type": "application/json",
      },
    };
    const request = await axios.post(
      "/api/users/login",
      userCredentials,
      config
    );
    const response = await request.data;
    console.log("AT thunk loginuser:", response);
    localStorage.setItem("user", JSON.stringify(response));
    return response;
  }
);

export const getAllUsers = createAsyncThunk("user/manage", async () => {
  const config = {
    header: {
      "Content-type": "application/json",
    },
  };
  try {
    const request = await axios.get("/api/users/getallusers", config);
    const response = await request.data;
    console.log("AT thunk:", response);
    localStorage.setItem("user", JSON.stringify(response));
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      console.error("Error response from server:", error.response.data);
      console.error("Status code:", error.response.status);
      console.error("Headers:", error.response.headers);
      // Show appropriate error message to the user
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request);
      // Show appropriate error message to the user
    } else {
      // Something happened in setting up the request that triggered an error
      console.error("Error setting up the request:", error.message);
      // Show appropriate error message to the user
    }
    // Handle error scenario (e.g., show error modal)
  }
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    user: null,
    error: null,
  },
  reducers: {
    logoutUser: (state, action) => {
      state.loading = true;
      state.user = null;
      state.error = null;
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.user = null;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = true;
        state.user = null;
        if (action.error.message === "Request failed with status code 401") {
          state.error = "Access Denied! Invalid Credentials";
        } else {
          state.error = action.error.message;
        }
      })
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
        localStorage.setItem("userInfo", JSON.stringify(action.payload));
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
  // reducers: {
  //   loginReducer: (state, action) => {
  //     const login = {
  //       id: nanoid(),
  //       text: action.payload,
  //     };
  //     state.login.push(login);
  //   },
  //   logoutReducer: (state, action) => {
  //     state.login = state.login.filter((login) => login.id !== action.payload);
  //   },
  // },
});

//export const { loginReducer, logoutReducer } = loginSlice.actions;
export const { logoutUser } = userSlice.actions;
export default userSlice.reducer;
export const selectUser = (state) => state.user;
